export default "__VITE_ASSET__CuI3eLfl__"